import {
  StyledSimilarProjectLogoSkeleton,
  StyledSimilarProjectTitleSkeleton,
  StyledSimilarProjectSubtitleSkeleton,
} from './styled'
import { SimilarProjectItemContainer } from '../styled'

export default function Loading() {
  return (
    <>
      {[...Array(3)].map((_, index) => (
        <SimilarProjectItemContainer key={index}>
          <StyledSimilarProjectLogoSkeleton variant="rectangular" />
          <StyledSimilarProjectTitleSkeleton />
          <StyledSimilarProjectSubtitleSkeleton />
        </SimilarProjectItemContainer>
      ))}
    </>
  )
}
